<template>
  <div class="ad-manage">
    <fixed-header title="地址管理"></fixed-header>
    <div class="ad-manage__main scroll-touch">
      <div class="ad-manage__box-wrap">
        <div v-if="defaultAddress.consignee" class="ad-manage__box">
          <section @click="gotoFromPage(defaultAddress.addressId)">
            <div class="ad-manage__user">
              <div>{{ defaultAddress.consignee }}</div>
              <div>{{ defaultAddress.mobile }}</div>
            </div>
            <div class="ad-manage__address--default">
              <div>[默认地址]</div>
              <div>{{ showAddress(defaultAddress) }}</div>
            </div>
          </section>
          <section @click="gotoEditPage(defaultAddress.addressId)">
            编辑
          </section>
        </div>
      </div>
      <div class="ad-manage__box-wrap">
        <div
            v-for="(item, index) in addressList"
            :key="index"
            class="ad-manage__box"
        >
          <section @click="gotoFromPage(item.addressId)">
            <div class="ad-manage__user">
              <div>{{ item.consignee }}</div>
              <div>{{ item.mobile }}</div>
            </div>
            <div class="ad-manage__address">
              {{ showAddress(item) }}
            </div>
          </section>
          <section @click="gotoEditPage(item.addressId)">编辑</section>
        </div>
      </div>
    </div>
    <div
        class="ad-manage__bottom"
        mg-stat-click
        mg-stat-custom="label=btn&cont=新增收货地址&direct=web&addr=haowu_address_edit"
        @click="gotoEditPage(0)"
    >
      <button>新增收货地址</button>
    </div>
  </div>
</template>
<script>
import FixedHeader from 'components/common/FixedHeader';
import * as userApis from 'apis/user';
import * as orderApi from 'apis/order';
import { showAddress } from 'utils/order';
import { mapMutations } from 'vuex';
import { getMgtvUserTicket, judgeLogin } from 'utils/user';

export default {
  components: { FixedHeader },
  data() {
    const {
      from, orderId, redirect, queryParams, goback,
    } = this.$route.query;
    return {
      query: this.$router,
      from,
      orderId,
      redirect,
      queryParams,
      goback,
      addressList: [],
      defaultAddress: {
        consignee: '',
        mobile: '',
        province: {
          id: '',
          name: '',
        },
        city: {
          id: '',
          name: '',
        },
        district: {
          id: '',
          name: '',
        },
        address: '',
        addressId: '',
        isDefault: 0,
      },
    };
  },
  created() {
    setTimeout(() => {
      const userInfo = getMgtvUserTicket();
      if (!(userInfo && userInfo.ticket)) {
        judgeLogin();
      } else {
        this.fetchAddressList();
      }
    }, 500);
  },
  methods: {
    showAddress,
    ...mapMutations('address', ['changeAddressId']),
    async fetchAddressList() {
      try {
        const data = await userApis.getAddressList();
        if (Array.isArray(data)) {
          const list = data.filter(f => !f.isDefault);
          const [defaultVal] = data.filter(f => f.isDefault);
          this.addressList = list;
          if (defaultVal) {
            this.defaultAddress = defaultVal;
          }
        }
      } catch (error) {
        this.$toast(`${error.message}`);
      }
    },
    gotoEditPage(id) {
      this.$router.push({ path: '/address/edit', query: { id } });
    },
    gotoFromPage(addressId) {
      if (!addressId) {
        return;
      }
      if (this.redirect) {
        const from_query = JSON.parse(this.queryParams);
        from_query.addressId = addressId;
        this.$router.push({ path: `/${this.from}`, query: from_query });
        return;
      } else if (
        this.from &&
          (this.from === 'detail' || this.from === 'jifen_shop_home') &&
          this.orderId
      ) {
        this.editOrderAddress(this.orderId, addressId);
      }
      if (this.goback) {
        this.changeAddressId(addressId);
        this.$router.go(-1);
      } else {
        this.$router.push({ path: '/pay', query: { addressId } });
      }
    },
    async editOrderAddress(orderId, addressId) {
      this.$loading.open();
      try {
        await orderApi.editOrderAddress({ orderId, addressId });
        this.$toast({ message: '提交成功', duration: 3000 });
        window.location.reload();
      } catch (error) {
        this.$toast({ message: `提交失败：${error.message}`, duration: 3000 });
      }
      this.$loading.close();
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">
.ad-manage {
  height: 100%;
  box-sizing: border-box;

  &__main {
    height: 100%;
  }

  &__box-wrap {
    margin: 30px 30px 20px 30px;
    background: #fff;
    border-radius: 20px;
  }

  &__box-wrap:last-child {
    margin-bottom: 140px;
  }

  &__box {
    width: 100%;
    padding: 30px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    border-bottom: 2px solid rgba(211, 211, 211, 0.5);

    section:first-child {
      flex: 1;
    }

    section:last-child {
      width: 62px;
      margin-left: 16px;
      font-size: 26px;
      text-align: right;
      color: #9b9b9b;
    }
  }

  &__box:last-child {
    border: none;
  }

  &__user {
    display: flex;
    justify-content: space-between;
    font-size: 34px;
    color: #000000;
    height: 56px;
    line-height: 56px;
  }

  &__address--default {
    display: flex;

    :first-child {
      width: 130px;
      margin-right: 30px;
      font-size: 26px;
      color: #ff5f00;
    }

    :last-child {
      flex: 1;
      font-size: 24px;
      color: #000000;
      word-break: break-all;
    }
  }

  &__address {
    font-size: 24px;
    color: #000000;
    word-break: break-all;
  }

  &__bottom {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 20px 36px;
    background: #fff;

    button {
      padding: 20px 0;
      width: 100%;
      font-size: 30px;
      color: #ffffff;
      background-image: linear-gradient(90deg, #fa841b 17%, #ff6002 85%);
      border-radius: 12px;
    }
  }
}
</style>
